import { Button } from "@mui/material";
import { useFormik } from "formik";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { getGalleryImageByIdFn, patchGalleryImageFn, postGalleryImageFn } from "../../../Services/GalleryImage";
import { getGalleryFn } from "../../../Services/Gallery";

export default function AddGalleryImage() {
  const { state: locationState } = useLocation();
  const { state: status } = useParams();

  const navigate = useNavigate();

  const { data: fetchedData } = useQuery({
    queryKey: ["get-gallery-image-by-id", locationState, status === "update"],
    queryFn: () => getGalleryImageByIdFn(locationState),
    enabled: !!locationState && status === "update",
  });

  const { data: getGallery } = useQuery({
    queryKey: ["get-category-by-id"],
    queryFn: getGalleryFn,
  });


  const { mutate: postImageGallery } = useMutation(postGalleryImageFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Added New Gallery");
        navigate("/gallery-image");
      }
    },
  });

  const { mutate: patchGalleryImage } = useMutation(patchGalleryImageFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Updated Gallery");
        navigate("/gallery-image");
      }
      if (response.data?.response_code === 201) {
        toast.success(response.data?.message);
      }
    },
  });

  const data = fetchedData?.data?.data;

  const formik = useFormik({
    initialValues: {
      title: data?.title || "",
      gallery: data?.gallery || "",
      image: null,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values);
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("image", values.image);
      formData.append("gallery", values.gallery);

      if (locationState && status === "update") {
        formData.append("gallery_image_id", locationState);
        if (!values.image) formData.delete("image");
        patchGalleryImage(formData);
      } else {
        if (!values.image) return toast.error("Image is required");
        postImageGallery(formData);
      }
    },
  });

  console.log(formik.values);

  return (
    <div className="flex flex-col justify-center gap-5 py-4 lg:flex-row">
      <div className="flex flex-col justify-center w-full lg:w-3/5">
        <div className="mt-5 bg-white shadow-lg">
          <form onSubmit={formik.handleSubmit}>
            <div className="p-2 border-gray-300 rounded-md">
              <div className="flex flex-col gap-5">
                <div className="  w-full pl-3">
                  <p className="p-1 text-sm font-semibold">Gallery</p>
                  <select
                    className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                    name="gallery"
                    value={formik.values.gallery}
                    onChange={formik.handleChange}
                  >
                    <option value="" disabled hidden>
                      Select Gallery
                    </option>
                    {getGallery?.data?.data.map((subCat) => (
                      <option key={subCat.id} value={subCat.id}>
                        {subCat.title}
                      </option>
                    ))}
                  </select>

                </div>
                <div className="w-full pl-3">
                  <div>
                    <p className="p-1 text-sm font-semibold">Title</p>
                    <input
                      id="title"
                      placeholder="Enter title"
                      value={formik.values.title}
                      className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
                <div className="w-full pl-3">
                  <div>
                    <p className="p-1 text-sm font-semibold">Image</p>
                    <input
                      id="image"
                      type="file"
                      className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                      onChange={(event) =>
                        formik.setFieldValue("image", event.target.files[0])
                      }
                    />
                  </div>
                </div>
                <div className="w-full pl-3">
                  <Button type="submit" variant="contained">
                    {status === "update" ? "Update" : "Add"}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
